import { Navigate, Outlet, useLocation } from 'react-router'
import { Spinner } from 'armxlib'
import { en } from '../../i18n/en'
import { ROUTES } from '../../routes'
import { useAuth } from './session'

/** Pages for signed-in users: sends anyone else to sign in, then back here. */
export function RequireAuth() {
  const { session, loading } = useAuth()
  const location = useLocation()
  if (loading) {
    return (
      <div className="page-loading">
        <Spinner label={en.common.loading} />
      </div>
    )
  }
  if (!session) {
    return <Navigate to={ROUTES.login.path} replace state={{ from: location.pathname }} />
  }
  return <Outlet />
}
